import { parseAsArrayOf, parseAsString } from 'nuqs';

/**
 * Filter URL keys are also column ids — `useServerDataTable` derives the
 * nuqs parser from each filterable column. API param names diverge from URL
 * keys (e.g. `rating` → `emissionsCategory`); the page maps them when
 * building the request.
 */
export enum GroupFoodAndDrinkFilterColumn {
  Search = 'name',
  Rating = 'rating',
  Family = 'family',
  Supplier = 'supplier',
}

const arrayOfStrings = parseAsArrayOf(parseAsString).withDefault([]);

export const groupFoodAndDrinkFilters = {
  [GroupFoodAndDrinkFilterColumn.Search]: { type: parseAsString },
  [GroupFoodAndDrinkFilterColumn.Rating]: { type: arrayOfStrings },
  [GroupFoodAndDrinkFilterColumn.Family]: { type: arrayOfStrings },
  [GroupFoodAndDrinkFilterColumn.Supplier]: { type: arrayOfStrings },
} as const;
